import React from 'react';
import { Plane } from 'lucide-react';
import TicketReminderCard from '../components/dashboard/TicketReminderCard';

const TicketReminders = () => {
  return (
    <div className="space-y-6" data-testid="ticket-reminders-page">
      <div className="flex items-center gap-3">
        <div className="bg-sky-100 p-2 rounded-lg">
          <Plane className="h-6 w-6 text-sky-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Ticket Due Reminder</h1>
          <p className="text-sm text-gray-500">
            Track company-paid flight tickets — upcoming dues, issued history and fare savings.
          </p>
        </div>
      </div>

      <TicketReminderCard />
    </div>
  );
};

export default TicketReminders;
